// Colors
export const border = "rgba(255,255,255,0.1)"
export const health = "#00a048"
export const background = "#000000"
export const typeLight = "rgba(255,255,255,0.55)"
export const foreground = "#FFFFFF"
